import * as React from "react";
import { motion } from "framer-motion";

export function Example() {
  const childVariants = {
    start: { rotate: -180 },
    hoverState: { borderRadius: 30 },
    tapState: { backgroundColor: "#f00" }
  };

  return (
    <motion.div
      style={{
        width: 150,
        height: 150,
        borderRadius: 30,
        backgroundColor: "#fff",
        display: "flex",
        placeItems: "center",
        placeContent: "center",
        cursor: "pointer"
      }}
      variants={{
        start: { rotate: 180, borderRadius: 30 },
        hoverState: { borderRadius: 75 },
        tapState: { backgroundColor: "#ffd700" }
      }}
      initial={{ borderRadius: 30 }} // Fix for a bug
      animate="start"
      whileHover="hoverState"
      whileTap="tapState"
    >
      <motion.div
        style={{
          width: 60,
          height: 60,
          borderRadius: 10,
          backgroundColor: "#fa2"
        }}
        variants={childVariants}
        initial={{ borderRadius: 10 }} // Fix for a bug
      />
    </motion.div>
  );
}
